// 登录api
import request from '@/tool/request'
const c = 'SignLogin/';

// 登录
export function login(query) {
  return request({
    url: c+'login',
    method: 'post',
    data:query
  })
}
// 退出登录
export function logout(query) {
  return request({
    url: c+'logout',
    method: 'post',
    data:query
  })
}